import PropTypes from 'prop-types';
import React from 'react';
import { UX2 } from '@wsb/guac-widget-core';
import {
  RouteHandler,
  ShopViewConstants,
  CartStore
} from '@wsb/guac-widget-shared/lib/common/ols-core/core-bundle';
import {
  CategoryListStore,
  ShopStore
} from '@wsb/guac-widget-shared/lib/common/ols-core/shop-bundle';
import dataAids from '../../constants/dataAids';
import * as Metrics from './utils/trackMetric';
import * as MetricEvents from '../../constants/metrics';
import { mapContextToProps } from '../components/OlsShopContext';

export class Breadcrumb extends React.Component {
  constructor() {
    super(...arguments);
    this.handleClick = this.handleClick.bind(this);
    this.onStoreChange = this.onStoreChange.bind(this);
    this.state = this.getStoreState();
  }

  getStoreState() {
    const { taxons, fetching } = CategoryListStore.getState();
    const { sortOption } = ShopStore.getState();

    return {
      fetching,
      taxons,
      sortOption
    };
  }

  componentDidMount() {
    CategoryListStore.addListener('change', this.onStoreChange);
  }

  componentWillUnmount() {
    CategoryListStore.removeListener('change', this.onStoreChange);
  }

  onStoreChange() {
    this.setState(this.getStoreState());
  }

  handleClick(e) {
    e.preventDefault();
    const { cart } = CartStore.getState();
    const beginningCartSize = cart && cart.line_items ? cart.line_items.length : 0;
    const { sortOption } = this.state;
    const data = sortOption ? { sortOption: sortOption } : {};
    Metrics.track(MetricEvents.CART_CONTINUE_SHOPPING_CLICK({ beginningCartSize }));
    RouteHandler.navigate(ShopViewConstants.PRODUCT_LISTING, data);
  }

  get isProductView() {
    const { currentView } = this.props;
    return currentView !== ShopViewConstants.CART;
  }

  get isEditProductDetailView() {
    const { currentView, editMode } = this.props;
    return currentView === ShopViewConstants.PRODUCT_DETAIL && editMode;
  }

  get taxonList() {
    return window?.history?.state?.params?.taxonSource || [];
  }

  get renderTaxonListBreadcrumbs() {
    const translate = this.props.translate;
    const { Link, Element } = UX2.Element;

    const separatorStyles = {
      display: 'inline-block',
      marginLeft: 'xsmall',
      marginRight: 'xsmall'
    };

    return (
      <Element>
        <Link
          { ...this.props.getLinkProps(ShopViewConstants.PRODUCT_LISTING) }
          onClick={ this.isEditProductDetailView ? '' : this.handleClick }
        >
          <Element
            data-aid={ dataAids.PRODUCTS_VIEW_ALL }
            children={ translate('products.view_all') }
          />
        </Link>
        { this.taxonList.map(taxon => {
          const data = { taxonPermalink: taxon.permalink };
          const linkProps = this.props.getLinkProps(ShopViewConstants.PRODUCT_LISTING, data);
          const handleClick = e => {
            e.preventDefault();
            RouteHandler.navigate(ShopViewConstants.PRODUCT_LISTING, data);
          };

          return (
            <Element>
              <Element style={ separatorStyles } children='/' />
              <Link
                { ...linkProps }
                onClick={ this.isEditProductDetailView ? '' : handleClick }
                children={ taxon.name }
              />
            </Element>
          );
        }) }
      </Element>
    );
  }

  render() {
    const translate = this.props.translate;
    const { currentView } = this.props;
    if (currentView === ShopViewConstants.PRODUCT_LISTING) {
      return null;
    }

    const { taxons, fetching } = this.state;
    const linkProps = this.props.getLinkProps(ShopViewConstants.PRODUCT_LISTING);
    const crumbText = !this.isProductView
      ? translate('products.continue_shopping')
      : translate('products.view_all');
    const isSearchResultsViewWCats = Boolean(
      currentView === ShopViewConstants.SEARCH_RESULTS && (taxons.length > 0 || fetching)
    );
    const styles = {
      container: {
        textAlign: 'left'
      },
      search: {
        '@sm': {
          display: 'none'
        }
      }
    };

    const displayTaxonBreadcrumbs = Boolean(this.isProductView && this.taxonList.length);

    return (
      <UX2.Element.Block style={ styles.container }>
        { displayTaxonBreadcrumbs && this.renderTaxonListBreadcrumbs }

        { !displayTaxonBreadcrumbs && (
          <UX2.Element.MoreLink.Backward
            href='javascript:;'
            { ...linkProps }
            onClick={ this.isEditProductDetailView ? '' : this.handleClick }
            style={ isSearchResultsViewWCats ? styles.search : {} }
          >
            <UX2.Element.Element data-aid={ dataAids.PRODUCTS_VIEW_ALL } children={ crumbText } />
          </UX2.Element.MoreLink.Backward>
        ) }
      </UX2.Element.Block>
    );
  }
}

Breadcrumb.propTypes = {
  currentView: PropTypes.string,
  editMode: PropTypes.bool,
  translate: PropTypes.func,
  getLinkProps: PropTypes.func
};

Breadcrumb.defaultProps = {
  translate: () => {}
};

export default mapContextToProps(Breadcrumb, context => ({
  getLinkProps: context.getLinkProps,
  translate: context.translate
}));
